"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var handlers = require("./handlers");
(0, analytics_layer_1.addSink)({
    name: "adobe_main_handler",
    handler: handlers.mainHander
});
